import useSWR from "swr";
import { fetcher } from "../../../common/hooks";
import { FirmwareUpdateSummary } from "../models";

export const useFirmwareUpdateSummary = ({
    companyId,
    locationId,
    refreshInterval = 0,
}: {
    companyId?: string;
    locationId?: string;
    refreshInterval?: number;
}) => {
    const getAPI = () => {
        if (!companyId || !locationId) {
            return null;
        }
        return `/api/device-management/v1/companies/${companyId}/locations/${locationId}/devices/firmware-update/summary`;
    };
    const { data, error, isLoading, mutate } = useSWR(getAPI(), fetcher, {
        fallbackData: [],
        refreshInterval,
    });

    return {
        summary: data as FirmwareUpdateSummary,
        isLoadingSummary: isLoading,
        isError: error,
        mutateSummary: mutate,
    };
};
